import Settings from '../olr-common/Settings';

export default function AdminService($http) {

  this.savePeople = function(reqObj) {
    let url = Settings.backendEnv + "/api/v1/addPeople";
    var req = {
      method:  "POST",
      url:    url,
      data:   reqObj
    };

    return $http(req);
  };

  this.updatePeople = function(reqObj) {
    let url = Settings.backendEnv + "/api/v1/updatePeople";

    var req = {method: "PUT", url: url, data: reqObj};
    return $http(req);

  };

  this.getStudentListByChar = function(charect, role){
    let url = Settings.backendEnv + "/api/v1/getPeopleChar/"+role + "/" + charect;

    var req = {method: "GET", url: url};
    return $http(req);
  }

  this.deletePeople = function(email, role){
    let url = Settings.backendEnv + "/api/v1/deletePeople/" + email + "/" + role;
    var req = {method: "DELETE", url: url};
    return $http(req);
  }

  this.getPeopleCount = function(){
    let url = Settings.backendEnv + "/api/v1/peopleCount";
    return $http({method: 'GET',url: url});
  };

  this.getAdmins = function(){
    let url = Settings.backendEnv + "/api/v1/getAdmin";
    return $http({method: 'GET',url: url});
  };

  this.getTeachers = function(){
    let url = Settings.backendEnv + "/api/v1/getTeacher";
    return $http({method: 'GET',url: url});
  };

  this.getStudents = function(){
    let url = Settings.backendEnv + "/api/v1/getStudent";
    return $http({method: 'GET',url: url});
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/AdminService.js
 **/